"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createTranslationSaga = void 0;

var effects_1 = require("redux-saga/effects");

var flat_1 = __importDefault(require("flat"));

var actions_1 = require("./actions");

var utils_1 = require("./utils");

var defaultTranslations = __importStar(require("./defaults"));

function createTranslationSaga(_ref) {
  var _marked = /*#__PURE__*/_regeneratorRuntime.mark(handleFetchTranslationsRequest);

  var getTranslation = _ref.getTranslation,
      translations = _ref.translations;

  function handleFetchTranslationsRequest(action) {
    var locale, result, allTransalations;
    return _regeneratorRuntime.wrap(function handleFetchTranslationsRequest$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            locale = action.payload.locale;

            if (!getTranslation) {
              _context.next = 8;
              break;
            }

            _context.next = 5;
            return effects_1.call(function () {
              return getTranslation(locale);
            });

          case 5:
            result = _context.sent;
            _context.next = 13;
            break;

          case 8:
            if (!translations) {
              _context.next = 12;
              break;
            }

            result = translations[locale];
            _context.next = 13;
            break;

          case 12:
            throw new Error('You must provide `translations` or `getTranslations`');

          case 13:
            // merge translations and defaults
            allTransalations = utils_1.mergeTranslations(flat_1.default(defaultTranslations[locale]), flat_1.default(result));
            utils_1.setCurrentLocale(locale, allTransalations);
            _context.next = 17;
            return effects_1.put(actions_1.fetchTranslationsSuccess(locale, allTransalations));

          case 17:
            _context.next = 23;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](0);
            _context.next = 23;
            return effects_1.put(actions_1.fetchTranslationsFailure(_context.t0.message));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _marked, null, [[0, 19]]);
  }

  return /*#__PURE__*/_regeneratorRuntime.mark(function translationSaga() {
    return _regeneratorRuntime.wrap(function translationSaga$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return effects_1.takeEvery(actions_1.FETCH_TRANSLATIONS_REQUEST, handleFetchTranslationsRequest);

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, translationSaga);
  });
}

exports.createTranslationSaga = createTranslationSaga;